"use strict";

require("./_text-section-2-3");